import { StorageUtil } from '../../../../../shared/utils/storage';
import { Field } from '../../../../settings/types/field';

import {
  getProspectSystemAttributes,
  getKanbanProspectSystemAttributes,
} from './get-prospect-system-attributes';

export const getDefaultSelectedProspectAttributes = (fields: Field[]) =>
  getProspectSystemAttributes(fields).filter((attr) => attr?.isDefault);

export const getProspectTableColumnsFromLocalStorage = () =>
  JSON.parse(StorageUtil.getItem('prospectTableColumns'));

export const setProspectTableColumnsInLocalStorage = (fields) => {
  StorageUtil.setItem('prospectTableColumns', JSON.stringify(fields));
};

export const removeProspectTableColumnsFromLocalStorage = () => {
  StorageUtil.removeItem('prospectTableColumns');
};

// Kanban card columns helpers
export const getDefaultSelectedKanbanCardAttributes = (fields: Field[]) =>
  getKanbanProspectSystemAttributes(fields).filter((attr) => attr?.isDefault);

export const getProspectKanbanCardColumnsFromLocalStorage = () => {
  const stored = StorageUtil.getItem('prospectKanbanCardColumns');
  return stored ? JSON.parse(stored) : null;
};

export const setProspectKanbanCardColumnsInLocalStorage = (fields) => {
  StorageUtil.setItem('prospectKanbanCardColumns', JSON.stringify(fields));
};

export const removeProspectKanbanCardColumnsFromLocalStorage = () => {
  StorageUtil.removeItem('prospectKanbanCardColumns');
};


// Currency code to symbol mapping
export const currencySymbolMap: Record<string, string> = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  JPY: '¥',
  CHF: 'CHF',
  CAD: 'C$',
  AUD: 'A$',
  CNY: '¥',
  INR: '₹',
  SGD: 'S$',
  HKD: 'HK$',
  NZD: 'NZ$',
  KRW: '₩',
  SEK: 'kr',
  AED: 'د.إ',
  BRL: 'R$',
  MXN: 'MX$',
  ZAR: 'R',
  SAR: '﷼',
  };
